import { loc } from "../../../../../core/utils"
import basketIconSVG from "../../../../atoms/icons/BasketIcon/basketIcon.svg"
import { arrayOf, shape } from "prop-types"
import React from "react"

export default function LineOfProduct({ mainProducts, accessoryProducts }) {
  const handleImageError = (currentTarget) => {
    currentTarget.onerror = null // prevents looping
    currentTarget.src = basketIconSVG
    currentTarget.setAttribute("style", "height: 30px; width: 30px")
  }

  return (
    <>
      <ul className="list-unstyled align-content-center no-mb">
        {mainProducts?.map((product) => (
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 12
            }}
            key={product.productName}
            className={mainProducts.length > 1 ? "product-title" : ""}
          >
            <span
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center"
              }}
              key={product.productName}
            >
              <div className="product-image product-image-container">
                <img
                  src={product.picture}
                  alt={`Product ${product.productName}`}
                  onError={({ currentTarget }) => handleImageError(currentTarget)}
                />
              </div>
              <h3 className="no-mb">{product.productName || ""}</h3>
            </span>
            <p
              className="no-mb"
              style={{
                fontSize: 18,
                fontWeight: 600,
                minWidth: "fit-content"
              }}
            >
              x {product.count}
            </p>
          </span>
        ))}

        {accessoryProducts?.length > 0 && <div style={{ marginBottom: 10 }}>{loc`Accessories`} :</div>}
        {accessoryProducts?.map((product) => (
          <React.Fragment key={product?.productName}>
            <li>
              <span
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
                key={product.productName}
                className={accessoryProducts.length > 1 ? "product-title" : ""}
              >
                <span
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  key={product.productName}
                >
                  <div className="product-image product-image-container">
                    <img
                      src={product.picture}
                      alt={`Product ${product.productName}`}
                      onError={({ currentTarget }) => handleImageError(currentTarget)}
                    />
                  </div>
                  <div className="no-mb">{product.productName || ""}</div>
                </span>
                <p
                  className="no-mb"
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    minWidth: "fit-content"
                  }}
                >
                  x {product.count}
                </p>
              </span>
            </li>
          </React.Fragment>
        ))}
      </ul>
    </>
  )
}

LineOfProduct.propTypes = {
  mainProducts: arrayOf(shape({})),
  accessoryProducts: arrayOf(shape({}))
}
